import { parseImgUrlProductImg } from 'src/filter/modules/img.js'
export function setHead(info, brand) {
	const { years, period, waveCode, serial, finishProductClass } = info;
	return {
		style: {
			textAlign: 'center'
		},
		children: [
			{

				text: `${years}年${period}期${waveCode}`
			},
			{
				text: `${brand == 6 ? '成品大类:' + finishProductClass : ' 系列:' + serial}`
			}
		]
	}
}

export function setTableHead() {
	return {
		style: {
			textAlign: 'center'
		},
		children: [
			{
				style: {
					width: '10%',
					flex: 'none'
				},
				children: [
					{
						text: '组别'
					}
				]
			},
			{
				style: {
					width: '15%',
					flex: 'none',
				},
				children: [
					{
						text: '面料'
					}
				]
			},
			{
				text: '款式'
			},
		]
	}
}
export function setMISSTableHead() {
	return {
		style: {
			textAlign: 'center'
		},
		children: [
			{
				style: {
					width: '15%',
					flex: 'none',
				},
				children: [
					{
						text: '面料'
					}
				]
			},
			{
				text: '款式'
			},
		]
	}
}

export function setTableCtx(info, brand) {
	let group = brand == 6 ?
		[{
			style: {
				textAlign: 'center',
				width: '15%',
				flex: 'none',
			},
			children: [
				{
					render(h) {
						return (
							<div class="order-manual__box-main">
								<p>{info.fabricMaterialGroup || ''}</p>
								<p>{info.masterMatDesc || ''}</p>
								<p>{info.masterMatCode || ''}</p>
							</div>
						)
					}
				}
			]
		}] : [
			{
				style: {
					textAlign: 'center',
					width: '10%',
					flex: 'none',
				},
				children: [
					{
						render(h) {
							return <div class="order-manual__box__left">{info.bookGroup || ''}</div>
						}
					}
				]
			},
			{
				style: {
					textAlign: 'center',
					width: '15%',
					flex: 'none',
				},
				children: [
					{
						render(h) {
							return (
								<div class="order-manual__box-main">
									<p>{info.fabricMaterialGroup || ''}</p>
									<p>{info.masterMatDesc || ''}</p>
									<p>{info.masterMatCode || ''}</p>
								</div>
							)
						}
					}
				]
			}
		]
	return {
		style: {
			height: '33mm',
			flex: 'none'
		},
		children: [
			...group,
			{
				render(h) {
					return (<div class="order-manual__box-content">
						{info.list && info.list.map((item, $index) => {
							const img = new Image();
							let isWidth;
							const className = 'img-' + (parseInt(Math.random() * 100000)) + '' + new Date().getTime();
							img.onload = function () {
								console.log('img.onload')
								isWidth = img.width > img.height ? true : false;
								setEleImg(isWidth);

							}
							img.src = parseImgUrlProductImg(item.imgUrl);
							if (img.complete) {
								console.log('img.complete')
								isWidth = img.width > img.height ? true : false;
								setEleImg(isWidth);
							}
							function setEleImg(flag) {
								const el = document.querySelector(`.${className}`);
								if (el) {
									el.style = flag ? 'width: 100%;height: auto' : 'width: auto;height: 100%';
								}
							}
							function isWidthStyle(flag) {
								if (flag === true) {
									return {
										width: '100%',
										height: 'auto'
									}
								}
								else if (flag === false) {
									return {
										height: '100%',
										width: 'auto'
									}
								} else {
									return {
										height: '100%',
										width: '100%'
									}
								}
							}
							const isN = item.materialCode.indexOf('N') === 0;
							return (<div class="order-manual-content">
								<div class="order-manual-content__left">
									<div class={`order-manual-content__img ${isN ? 'isN' : null}`}>
										<img class={className} src={img.src}></img>
									</div>
									{isN === false ? (
										brand == '6' ? <div>
											<p>{item.materialCode || ''}</p>
											<p>{item.materialDescCn || ''}</p>
											<p>{item.serial || ''}</p>
											<p>{item.developer || ''}</p>
											<p>{item.size || ''}</p>
											<p>{item.productLine || ''}</p>
											<p>{item.pattern || ''}</p>
											<p>{item.tagPrice || ''}</p>
											<p>{item.projectTagPrice || ''}</p>
											<p>{item.materialGroup || ''}</p>
										</div> : <div>
											<p>{item.materialCode || ''}</p>
											<p>{item.pattern || ''}</p>
											<p>{item.tagPrice || ''}</p>
											<p>{item.projectTagPrice || ''}</p>
										</div>
									) : null}
								</div>
								<div class="order-manual-content__right">
									<p style="text-wrap: wrap;">{item.bookColorMatch || ''}</p>

								</div>
							</div>)
						})}</div>)
				},
			}
		]
	}
}

export function getTable(info, brand) {
	return {
		style: {
			flexDirection: "column"
		},
		children: [
			setHead(info, brand),
			brand == '6' ? setMISSTableHead() : setTableHead(),
			...info.list.map(item => {
				return setTableCtx(item, brand)
			})

		]
	}
}

export function foramtPrintInfo(list, col) {
	const MAX = 8;
	return list.map(item => {
		const { years, period, waveCode, serial, finishProductClass } = item;
		const innerArray = item.itemList.reduce((pre, next) => {
			const { materialGroup: fabricMaterialGroup , masterMatCode, masterMatDesc, bookGroup } = next;

			const materialVOList = next.materialVOList.reduce(
				(innerPre, innerNext) => {
					const length = innerPre.length;
					if (innerPre[length - 1].list.length >= col) {
						innerPre.push({fabricMaterialGroup, masterMatCode, masterMatDesc, bookGroup, list: [] });
					}
					innerPre[innerPre.length - 1].list.push(innerNext);
					return innerPre;
				},
				[{ fabricMaterialGroup, masterMatCode, masterMatDesc, bookGroup, list: [] }]
			);
			return pre.concat(materialVOList);
		}, []);

		const pageArray = innerArray.reduce(
			(pre, next) => {
				if (pre[pre.length - 1].list.length >= MAX) {
					pre.push({ years, period, waveCode, serial, finishProductClass, list: [] });
				}
				pre[pre.length - 1].list.push(next);
				return pre;
			},
			[{ years, period, waveCode, serial, finishProductClass, list: [] }]
		);

		if (
			pageArray[pageArray.length - 1] &&
			pageArray[pageArray.length - 1].list &&
			pageArray[pageArray.length - 1].list.length < MAX
		) {
			while (pageArray[pageArray.length - 1].list.length < MAX) {
				pageArray[pageArray.length - 1].list.push({ list: [] });
			}
		}

		// array.push(pageArray);
		return pageArray
	});
}
